import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import type { Dayjs } from 'dayjs';

import { BlurredAztecCode } from '../../../atoms/BlurredAztecCode/BlurredAztecCode';
import { MplTicketValidity } from '../../MplTicketValidity';

import {
	MplDeutschlandTicketCardHeader,
	MplDeutschlandTicketCardSeparator,
	MplDeutschlandTicketNameAndStatus,
	MplDeutschlandTicketRemainingTimeLeft,
	StyledBottomContainer,
	StyledCardContainer,
	StyledTicketContainer,
	StyledTicketDetailsSection,
} from './components';

interface IMplDeutschlandTicketCardPreOrderedProps {
	firstName: string;
	lastName: string;
	formattedPrice: string;
	validFrom: Dayjs;
	validUntil: Dayjs;
}

export const MplDeutschlandTicketCardPreOrdered: FC<
	IMplDeutschlandTicketCardPreOrderedProps
> = ({ firstName, lastName, formattedPrice, validFrom, validUntil }) => {
	const { t } = useTranslation('userDTicket');
	return (
		<StyledTicketContainer>
			<StyledCardContainer>
				<MplDeutschlandTicketCardHeader formattedPrice={formattedPrice} />
				<MplDeutschlandTicketCardSeparator />
				<StyledBottomContainer>
					<StyledTicketDetailsSection>
						<MplDeutschlandTicketNameAndStatus
							firstName={firstName}
							lastName={lastName}
							statusText={t('dticket_large.status.preordered')}
							statusVariant="info"
						/>
						<Stack gap={0.5}>
							<MplTicketValidity
								validityLabel={t('dticket_large.validity')}
								validFrom={validFrom}
								validUntil={validUntil}
							/>

							<MplDeutschlandTicketRemainingTimeLeft
								endDate={validFrom}
								isPreordered={true}
							/>
						</Stack>
					</StyledTicketDetailsSection>
					<BlurredAztecCode paused={false} />
				</StyledBottomContainer>
			</StyledCardContainer>
		</StyledTicketContainer>
	);
};
